import React, { useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import useAccessibilityClick from '../../hooks/useAccessibilityClick';
import itemBankService from '../services/ItemBankService';

const DeleteItemFromAssessmentButton = (props) => {
  const { itemId } = props;
  const { refreshCallback, setErrorMessage } = props;

  const addRef = useRef();

  useAccessibilityClick(addRef, () => {
    const doDelete = async () => {
      const status = await itemBankService.removeItemFromLessonService(itemId);
      if (status && status !== 'SUCCESS') {
        setErrorMessage(`Error removing item from assessment: ${status}`);
      } else {
        if (refreshCallback) {
          await refreshCallback();
        }
      }
    };
    ReactTooltip.hide();
    doDelete();
  });

  return (
    <>
      <ReactTooltip border effect='solid' type='light' />
      <div ref={addRef} aria-label='remove item from assessment' className='delete-from-assessment-button' data-tip='Remove item from assessment.'
        data-tool='quick remove' />
    </>
  );
};

export default DeleteItemFromAssessmentButton;
